export default __webpack_public_path__ + "static/media/Snd_FrogJump.925e4c8d.mp3";